import {
  Card,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  ToothSample,
  User,
  Hospital,
  initHospital,
  initProvince,
  Province,
  City,
  initCity,
  County,
  initCounty,
} from "../../../models";
import { getTable, getTableAll } from "../../../api/Api";
import { useHistory } from "react-router-dom";
interface PropsType {
  editRecord: ToothSample;
  setAge: Function;
}
export const HospitalPerson: React.FC<PropsType> = ({ editRecord, setAge }) => {
  const [provinceOptions, setProvinceOptions] = useState<any[]>([]);
  const [cityOptions, setCityOptions] = useState<any[]>([]);
  const [countyOptions, setCountyOptions] = useState<any[]>([]);
  const [hospitalOptions, setHospitalOptions] = useState<any[]>([]);

  const [province, setProvince] = useState(initProvince);
  const [city, setCity] = useState(initCity);
  const [county, setCounty] = useState(initCounty);
  const [hospital, setHospital] = useState(initHospital);
  //const [loading,setLoading]=useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    getProvinceOptions();
    if (editRecord.id !== -1) {
      initData();
      form.setFieldsValue({ ...editRecord });
    } else {
      form.setFieldsValue({
        province: "",
        city: "",
        county: "",
        hospital: "",
        sex: undefined,
        name: "",
        age: 5,
        ageMonth:0,
        phoneNo: "",
        className: "",
        gradeName: "",
        schoolName: "",
        sender: "",
        checker:'',
      });
    }
  }, [editRecord, form]);

  const initData = async () => {
    //setLoading(true);
    if (editRecord.hospitalId >= 0) {
      let h: Hospital = await getTable("hospital", editRecord.hospitalId);
      if (typeof h !== "undefined") {
        setHospital(h);
        if (h.provinceId !== -1) {
          let p: Province = await getTable("province", h.provinceId);
          if (typeof p === "undefined") {
            //setLoading(false);
            history.push("/");
          }
          setProvince(p);
        }
        if (h.cityId !== -1) {
          let c: City = await getTable("city", h.cityId);
          if (typeof c === "undefined") {
            //setLoading(false);
            history.push("/");
          }
          setCity(c);
        }
        if (h.countyId !== -1) {
          let c: County = await getTable("county", h.countyId);
          if (typeof c === "undefined") {
            //setLoading(false);
            history.push("/");
          }
          setCounty(c);
        }
      }
    }
    //setLoading(false);
  };

  const getProvinceOptions = async () => {
    let items: any[] = [];
    //setLoading(true);
    let ps: Province[] = await getTableAll("province");
    if (typeof ps === "undefined") {
      //setLoading(false);
      history.push("/");
    }
    ps.forEach((d) => {
      items.push(
        <Select.Option key={d.id} value={d.id}>
          {d.name}
        </Select.Option>
      );
    });
    setProvinceOptions(items);
    //setLoading(false);
  };

  const getCityOptions = async (p: Province) => {
    let items: any[] = [];
    //setLoading(true);
    let cs: City[] = await getTableAll("city");
    if (typeof cs === "undefined") {
      //setLoading(false);
      history.push("/");
    }
    cs.forEach((d) => {
      if (d.provinceId === p.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.name}
          </Select.Option>
        );
    });
    setCityOptions(items);
  };
  const getCountyOptions = async (c: City) => {
    let items: any[] = [];
    //setLoading(true);
    let cs: County[] = await getTableAll("county");
    if (typeof cs === "undefined") {
      //setLoading(false);
      history.push("/");
    }
    cs.forEach((d) => {
      if (d.cityId === c.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.name}
          </Select.Option>
        );
    });
    setCountyOptions(items);
    //setLoading(false);
  };

  const getHospitalOptions = async (c: County) => {
    let items: any[] = [];
    //setLoading(true);
    let hs: Hospital[] = await getTableAll("hospital");
    if (typeof hs === "undefined") {
      //setLoading(false);
      history.push("/");
    }
    hs.forEach((d) => {
      if (d.countyId === c.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.hospitalName}
          </Select.Option>
        );
    });
    setHospitalOptions(items);
    //setLoading(false);
  };

  const onItemChange = (e: any) => {
    editRecord.sex = form.getFieldValue("sex");
    editRecord.name = form.getFieldValue("name");
    editRecord.className = form.getFieldValue("className");
    editRecord.gradeName = form.getFieldValue("gradeName");
    editRecord.schoolName = form.getFieldValue("schoolName");
    editRecord.phoneNo = form.getFieldValue("phoneNo");
    editRecord.sender = form.getFieldValue("sender");
    editRecord.checker = form.getFieldValue("checker");
    editRecord.ageMonth = parseInt(form.getFieldValue("ageMonth"));
  };
  const onAgeChange = (e: any) => {
    let age1 = parseInt(e.target.value);
    editRecord.age = age1;
    setAge(age1);
  };
  const onProvinceChange = async (e: any) => {
    let p: Province = await getTable("province", e);
    if (typeof p === "undefined") {
      history.push("/");
    }
    setProvince(p);
    getCityOptions(p);
    setCountyOptions([]);
    setHospitalOptions([]);
    setCity(initCity);
    setCounty(initCounty);
    setHospital(initHospital);
  };

  const onCityChange = async (e) => {
    let c: City = await getTable("city", e);
    if (typeof c === "undefined") {
      history.push("/");
    }
    setCity(c);
    getCountyOptions(c);
    setHospitalOptions([]);
    setCounty(initCounty);
    setHospital(initHospital);
  };

  const onCountyChange = async (e) => {
    let c: County = await getTable("county", e);
    if (typeof c === "undefined") {
      history.push("/");
    }
    setCounty(c);
    getHospitalOptions(c);
    setHospital(initHospital);
  };

  const onHospitalChange = async (e) => {
    let h: Hospital = await getTable("hospital", e);
    if (typeof h === "undefined") {
      history.push("/");
    }
    editRecord.hospitalId = h.id;
    editRecord.hospitalName = h.hospitalName;
    setHospital(h);
    editRecord.hospitalId = h.id;
    editRecord.hospitalName = h.hospitalName;
  };
  return (
    <Card title="受检人信息" style={{ background: "#ececec", margin: "10px" }}>
      
      <Form
        layout="horizontal"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        form={form}
      >
        <Row>
          <Col span={12}>
            <Form.Item name="province" label="所在省份">
              <Select
                value={province.name}
                onChange={onProvinceChange}
                placeholder="请选择..."
              >
                {provinceOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="schoolName" label="学校/幼儿园">
              <Input onChange={onItemChange} placeholder="请输入" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="city" label="所在市、区">
              <Select
                value={city.name}
                onChange={onCityChange}
                placeholder="请选择..."
              >
                {cityOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="gradeName" label="所在年级">
              <Input onChange={onItemChange} placeholder="请输入" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item name="county" label="所在县、区">
              <Select
                value={county.name}
                onChange={onCountyChange}
                placeholder="请选择..."
              >
                {countyOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="className" label="所在班级">
              <Input onChange={onItemChange} placeholder="请输入" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="hospital" label="检测医院">
              <Select onChange={onHospitalChange} placeholder="请选择...">
                {hospitalOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="name" label="姓名">
              <Input onChange={onItemChange} placeholder="请输入" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="sex" label="性别">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"男"}>男</Radio>
                <Radio value={"女"}>女</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="age" label="年龄(岁)">
              <Input onChange={onAgeChange} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="ageMonth" label="年龄(月)">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="phoneNo" label="电话号码">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>        
          <Col span={12}>
            <Form.Item name="sender" label="送检者">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="checker" label="检测医生">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>        
          </Row>
      </Form>
      
    </Card>
  );
};
